import escuelasCertificadas from '../../graduados/reportes/escuelasCertificadas'
import estudiantesSeleccionados from '../../graduados/reportes/estudiantesSeleccionados'
import progresoTransacciones from '../../monitoria/reportes/progresoTransacciones'
import statusTransacciones from '../../monitoria/reportes/statusTransacciones'
export default {
    components: {
        escuelasCertificadas,
        estudiantesSeleccionados,
        progresoTransacciones,
        statusTransacciones
    },
    data: () => ({
        isAdmin: false,
        isMonitor: false,
        isGrad: false,
        isDiploma: false,
        isEstadisticos: false,
        refresh: null
    }),
    created() {
         this.LoadGraphics()
    },
    methods: {
        LoadGraphics() {
            this.isAdmin = this.$parent.$parent.$parent.isAdmin
            this.isMonitor = this.$parent.$parent.$parent.isMonitor
            this.isEstadisticos = this.$parent.$parent.$parent.isEstadisticos
            this.isGrad = this.$parent.$parent.$parent.isGrad
            this.isDiploma = this.$parent.$parent.$parent.isDiploma
        }
    },
    computed: {
        viewEscuelasCertificadas() {
            return (this.isAdmin || this.isGrad || this.isEstadisticos)
        },
        viewEstudiantesSeleccionados() {
            return (this.isAdmin || this.isGrad || this.isEstadisticos)
        },
        viewProgresoTransacciones() {
            return (this.isAdmin || this.isMonitor || this.isEstadisticos)
        },
        viewStatusTransacciones() {
            return (this.isAdmin || this.isMonitor || this.isEstadisticos) 
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/index/script.js